import { baseAPIRequest } from 'utilities/http';

async function getProductDeliveryDate (shortSku, isOpenBox = false, usePostalCode = false, quantity = 1) {

	if (!shortSku) {

		return;

	}

	try {

		const response = await baseAPIRequest({
			url: '/api/product-shipping/product-delivery-date/',
			data: {
				ShortSku: shortSku,
				Quantity: quantity,
				UseProductDetailPostalCode: usePostalCode,
				IsOpenBox: isOpenBox
			},
			params: {
				method: 'POST'
			}
		});
		return response;

	} catch (error) {

		console.log(error);

	}

}

export default getProductDeliveryDate;
